import { Card, Col, Container, Row } from 'react-bootstrap'
import { useEffect } from 'react'
import AOS from 'aos'
import './WorkCard.css'


const WorkCard = ({ works }) => {
    useEffect(() => {
        AOS.init({
            duration : 1500
        })
        AOS.refresh()
    }, [])

    return (
        <Container className='workCard'>
            <Row className='justify-content-center'>
                <h2>Te ofrecemos</h2>
                {
                    works.map(elm => {
                        return (
                            <Col sm={12} key={elm.id} data-aos='fade-down'>
                                <Card>
                                    <img src={elm.img} alt={elm.name} />
                                    <Card.Body>
                                        <h3>{elm.name}</h3>
                                        <p>{elm.text}</p>
                                    </Card.Body>
                                </Card > 
                            </Col>
                        )
                    })
                }
            </Row>
        </Container>
    )
}

export default WorkCard